<i class="container" [class]="iconClass()">{{ value() }}</i>
